<!--
텍스트 박스
------------------------------------
사용 예 )
------------------------------------
값 바인딩 : 일반 텍스트 바인딩
    <app-input-text
        value="초기값"
    > </app-input-text>

------------------------------------
값 바인딩 : 부모 컴포넌트의 data 바인딩
    <app-input-text
        :value="columns.p_name"
    > </app-input-text>

------------------------------------
값 바인딩 : 부모 컴포넌트의 data v-model 처리
    <app-input-text
        v-model="columns.p_name"
    > </app-input-text>

------------------------------------
값 바인딩 : 부모 컴포넌트 에서 값변경 이벤트 리스닝 
    <app-input-text
        value="초기값"
        @update:value="val => vvv = val "
    > </app-input-text>
    {{ vvv }}

    <script>
    {
        data: {
            vvv: null
        }
    }
    </script>

------------------------------------
값 바인딩 : 부모 컴포넌트 sync 처리
    <app-input-text
        :value.sync="columns.p_name"
    > </app-input-text>

------------------------------------
사이즈 설정
    <app-input-text
        input-size="small or large"
    > </app-input-text>

------------------------------------
id, name, placeholder 설정
    <app-input-text
        id="aaa"
        name="bbb"
        placeholder="ccc"
    > </app-input-text>

------------------------------------
검증 설정 - 검증규칙 객체를 넘기는 경우
    <app-input-text
        :validate-rules="{required: true, title: 'title'}"
    > </app-input-text>

------------------------------------
검증 설정 - 프라미스 생성 함수명을 넘기는 경우
    <app-input-text
        validate-rules="func_name"
    > </app-input-text>

------------------------------------
포커싱 기능 - 요소를 선택하면 색상이 하이라이트됨

------------------------------------
setFocus() - 요소에 포커싱 설정
    <app-input-text
        ref="aaa"
    > </app-input-text>

    <button type="button" @click="$refs.aaa.inputFocus()">포커싱</button>

------------------------------------
setError() - 요소를 검증오류로 설정
    <app-input-text
        ref="aaa"
    > </app-input-text>

    <button type="button" @click="$refs.aaa.setState('error', '오류메세지')">오류설정</button>

------------------------------------
속성으로 오류 설정
    <app-input-text
        init-error-msg="에러내용"
    > </app-input-text>

-->
<template>
    <div :class="classObject" :style="[defaultCssVariables, cssVariables]">
        <input 
            type="text"
            class="uk-input"
            :style="textStyle"

            :id="id"
            :name="name"
            :placeholder="placeholder"
            :class=" inputSizeClass"
            :value="value"
            @input="updateValue"
            @focus="focus"
            @focusout="focusout"

            :readonly="readonly"
            :disabled="disabled"


            @keyup="e => $emit('keyup', e)"
        />
    </div>
</template>

<script>
    import InputBase from './base.vue';

    export default {
        extends: InputBase,
    }
</script>